import { create } from 'zustand';
import type { Menu, User } from '@/types';

type StoreState = {
  collapseSidebar: boolean;
  changeCollapseSidebar: (collapse: boolean) => void;
  currentLoading: boolean;
  changeCurrentLoading: (loading: boolean) => void;
  currentMenus: Menu[];
  changeCurrentMenus: (menus: Menu[]) => void;
  currentSystemMenus: Menu[];
  changeCurrentSystemMenus: (menus: Menu[]) => void;
  currentUser: User | null;
  changeCurrentUser: (user: User | null) => void;
  currentMenu: Menu | null;
  changeCurrentMenu: (menu: Menu | null) => void;
  currentSubmenu: Menu | null;
  changeCurrentSubmenu: (menu: Menu | null) => void;
  currentThirdMenu: string | null;
  changeCurrentThirdMenu: (menu: string | null) => void;
};

export const useStore = create<StoreState>()((set) => ({
  collapseSidebar: false,
  changeCollapseSidebar: (collapse) => {
    set(() => ({
      collapseSidebar: collapse,
    }));
  },
  currentLoading: false,
  changeCurrentLoading: (loading) => {
    set(() => ({
      currentLoading: loading,
    }));
  },
  currentMenus: [],
  changeCurrentMenus: (menus) => {
    set(() => ({
      currentMenus: menus,
    }));
  },
  currentSystemMenus: [],
  changeCurrentSystemMenus: (menus) => {
    set(() => ({
      currentSystemMenus: menus,
    }));
  },
  currentUser: null,
  changeCurrentUser: (user) => {
    set(() => ({
      currentUser: user,
    }));
  },
  currentMenu: null,
  changeCurrentMenu: (menu) => {
    set(() => ({
      currentMenu: menu,
    }));
  },
  currentSubmenu: null,
  changeCurrentSubmenu: (menu) => {
    set(() => ({
      currentSubmenu: menu,
    }));
  },
  currentThirdMenu: null,
  changeCurrentThirdMenu: (menu) => {
    set(() => ({
      currentThirdMenu: menu,
    }));
  },
}));
